import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const ThresholdFields = ({ form, handleNestedChange }) => {
  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Threshold Amount"
          type="number"
          value={form.config.thresholdAmount || ""}
          onChange={(e) =>
            handleNestedChange(
              "config",
              "thresholdAmount",
              Number(e.target.value)
            )
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          select
          label="Discount Type"
          value={form.config.discountType || "percentage"}
          onChange={(e) =>
            handleNestedChange("config", "discountType", e.target.value)
          }>
          <MenuItem value="percentage">%</MenuItem>
          <MenuItem value="fixed">$</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Discount Value"
          type="number"
          value={form.config.discountValue || ""}
          onChange={(e) =>
            handleNestedChange(
              "config",
              "discountValue",
              Number(e.target.value)
            )
          }
        />
      </Grid>
    </Grid>
  );
};

export default ThresholdFields;
